// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__25zCB","selected":"Chip_selected__3JUkE"};